import { Navigate, useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
import Page404 from "./pages/Page404";

import GuestListing from "./pages/admin/guest-listing";

import LoginPage from "./pages/admin/login";

import { useStore } from "./App";
import CompaniesListing from "./pages/admin/companies-listing";
import MeetingsListing from "./pages/admin/company-meetings-listing";
import InvestorsListing from "./pages/admin/investors-listing";
import InvestorMeetingsListing from "./pages/admin/investor-meetings-listing";
import Feedbacks from "./pages/admin/feedbacks";
import SlotWiseMeetingsListing from "./pages/admin/slot-wise-meetings-listing";

const AdminRoute = ({ children }) => {
  const userStatus = useStore((state) => state.userStatus);

  return userStatus === true ? children : <Navigate to="/" />;
};

const RedirectAdmin = ({ children }) => {
  const userStatus = useStore((state) => state.userStatus);

  return userStatus === true ? (
    <Navigate to="/companies-listing" replace />
  ) : (
    children
  );
};

export default function Router() {
  const routes = useRoutes([
    {
      element: <DashboardLayout />,
      children: [
        {
          path: "companies-listing",
          element: (
            <AdminRoute>
              <CompaniesListing />
            </AdminRoute>
          ),
        },
        {
          path: "company-meetings/:id",
          element: (
            <AdminRoute>
              <MeetingsListing />
            </AdminRoute>
          ),
        },
        {
          path: "slot/:name/meetings",
          element: (
            <AdminRoute>
              <SlotWiseMeetingsListing />
            </AdminRoute>
          ),
        },
        {
          path: "investors-listing",
          element: (
            <AdminRoute>
              <InvestorsListing />
            </AdminRoute>
          ),
        },
        {
          path: "investor-meetings/:id",
          element: (
            <AdminRoute>
              <InvestorMeetingsListing />
            </AdminRoute>
          ),
        },
        {
          path: "feedbacks",
          element: (
            <AdminRoute>
              <Feedbacks />
            </AdminRoute>
          ),
        },
        // {
        //   path: "guest-listing",
        //   element: (
        //     <AdminRoute>
        //       <GuestListing />
        //     </AdminRoute>
        //   ),
        // },
      ],
    },
    {
      path: "",
      element: (
        <RedirectAdmin>
          <LoginPage />
        </RedirectAdmin>
      ),
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);

  return routes;
}
